import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const SellIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.6272 6.04297C11.0177 6.43349 11.0177 7.06666 10.6272 7.45718C10.2367 7.84771 9.60351 7.84771 9.21298 7.45718C8.82246 7.06666 8.82246 6.43349 9.21298 6.04297C9.60351 5.65244 10.2367 5.65244 10.6272 6.04297Z"
      fill="currentColor"
    />
    <path
      d="M6.3599 15.2603L1.41016 10.3105L7.42056 4.30014H12.3703V9.24989L6.3599 15.2603Z"
      stroke="currentColor"
    />
    <path
      d="M12.3849 6.77532C13.0164 6.76905 13.6459 6.52501 14.1277 6.04321C15.104 5.0669 15.104 3.48399 14.1277 2.50768C13.1514 1.53137 11.5685 1.53137 10.5922 2.50768C10.1104 2.98948 9.86632 3.619 9.86004 4.25044L9.86004 6.77532"
      stroke="currentColor"
    />
  </svg>,
  'sell'
);
